import "./FishWeek.scss";
import Slide from "./components/Slide";
import { useEffect, useState } from "react";
import { getFishOfTheWeek } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function FishWeek() {
  const { t } = useTranslation();
  const [cookie] = useCookies(["access_token"]);
  const [fishes, setFishes] = useState([]);

  useEffect(() => {
    getFishOfTheWeek(cookie.access_token).then((res) => setFishes(res?.data));
  }, []);

  return (
    <div className="fish-of-the-week">
      <div className="dots"></div>
      <div className="title-description">
        <div className="title">
          <p>{t("fish-of-the-week")}</p>
        </div>
        <div className="salmon-rectangle"></div>
        <div className="description">{t("fish-of-the-week-description")}</div>
      </div>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        scrollbar={{ draggable: true }}
        className="swiper"
        spaceBetween={10}
        slidesPerView={1}
        centeredSlides={false}
        loop={false}
        direction="horizontal"
        observeParents={true}
        parallax={true}
        breakpoints={{
          767: {
            slidesPerView: 1.8,
          },
          1000: {
            slidesPerView: 2.3,
          },
          1200: {
            slidesPerView: 3,
          },
          1350: {
            slidesPerView: 3.5,
          },
          1500: {
            slidesPerView: 4,
          },
          1700: {
            slidesPerView: 4.5,
          },
        }}
        touchEventsTarget="container"
      >
        {fishes?.map((fish, index) => {
          return (
            <SwiperSlide>
              <Slide
                key={index}
                id={fish.id}
                name={fish.name}
                price={fish.price}
                image={fish?.images?.length > 0 ? fish.images[0].url : ""}
              ></Slide>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
